<template>
    <div id="ScannedContact" ref="contact_section">
        <PetButtonDropDown
            :expanded="true"
            :hide-expand="!ownerdata.phone && !ownerdata.contact_email && !ownerdata.whatsapp"
            v-if="pet_data && ownerdata"
            :address_privacy="
                !(pet_data.settings_privacy && pet_data.settings_privacy.showContact)
            "
            :img_src="ownerdata.photo"
            :name="ownerdata.fname + ' ' + ownerdata.lname"
            :colored_text="getLabelData(ownerdata.label)"
        >
            <div>
                <div
                    class="pet-content-group"
                    v-if="pet_data.settings_privacy && pet_data.settings_privacy.showContact"
                >
                    <div class="coalition-text">
                        <a
                            class="btn-gray left-btn"
                            :href="'tel:'+ ownerdata.phone"
                            v-if="!processing && !feedback && ownerdata.phone"
                        >
                            <div class="btn-gray-svg">
                                <svg
                                    height="18"
                                    width="18"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M7.58337 1.89724C8.84495 1.53778 10.2333 1.83553 11.1989 2.80112C12.1645 3.76672 12.4623 5.15509 12.1028 6.41667M8.71323 3.47904C9.16382 3.38929 9.68282 3.54474 10.0691 3.93098C10.4553 4.31722 10.6107 4.83621 10.521 5.28681"
                                        stroke="#F5C042"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M8.84643 12.182C9.36067 12.2727 9.88933 12.2727 10.4036 12.182C11.2301 12.0364 11.8958 11.4815 12.1252 10.7471L12.1738 10.5913C12.2244 10.4294 12.25 10.2619 12.25 10.0936C12.25 9.35157 11.5864 8.75 10.7677 8.75H8.48229C7.66364 8.75 7 9.35157 7 10.0936C7 10.2619 7.02564 10.4294 7.0762 10.5913L7.12484 10.7471C7.35416 11.4815 8.01991 12.0364 8.84643 12.182ZM8.84643 12.182C5.27447 11.5202 2.4798 8.72553 1.81796 5.15357M1.81796 5.15357C1.72735 4.63933 1.72735 4.11067 1.81796 3.59644C1.9636 2.76991 2.51851 2.10416 3.25291 1.87484L3.40868 1.8262C3.5706 1.77564 3.73807 1.75 3.90635 1.75C4.64843 1.75 5.25 2.41364 5.25 3.23229L5.25 5.51771C5.25 6.33636 4.64843 7 3.90635 7C3.73807 7 3.5706 6.97436 3.40868 6.9238L3.2529 6.87516C2.51851 6.64584 1.9636 5.98009 1.81796 5.15357Z"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                    />
                                </svg>
                            </div>
                            <p>Phone</p>
                        </a>
                        <a
                            class="btn-gray right-btn"
                            :href="'mailto:'+ ownerdata.contact_email"
                            v-if="!processing && !feedback && ownerdata.contact_email"
                        >
                            <div class="btn-gray-svg">
                                <svg
                                    height="18"
                                    width="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M3.66255 4.26505C3.32552 4.02426 2.8571 4.10228 2.61631 4.43931C2.37552 4.77635 2.45354 5.24477 2.79057 5.48556L3.66255 4.26505ZM7.56173 7.97253L7.12573 8.58279L7.56173 7.97253ZM10.438 7.97253L10.002 7.36228L10.438 7.97253ZM15.2092 5.48556C15.5462 5.24477 15.6242 4.77635 15.3834 4.43931C15.1426 4.10228 14.6742 4.02426 14.3372 4.26505L15.2092 5.48556ZM2.79057 5.48556L7.12573 8.58279L7.99772 7.36228L3.66255 4.26505L2.79057 5.48556ZM10.874 8.58279L15.2092 5.48556L14.3372 4.26505L10.002 7.36228L10.874 8.58279ZM7.12573 8.58279C8.24683 9.38375 9.75291 9.38375 10.874 8.58279L10.002 7.36228C9.40252 7.79058 8.59722 7.79058 7.99772 7.36228L7.12573 8.58279Z"
                                        fill="#F5C042"
                                    />
                                    <path
                                        d="M2.16404 11.3634L2.89194 11.1827L2.16404 11.3634ZM2.16404 6.63656L2.89194 6.81731L2.16404 6.63656ZM15.836 6.63657L16.5639 6.45582L15.836 6.63657ZM15.836 11.3634L16.5639 11.5442L15.836 11.3634ZM11.3367 15.4942L11.1744 14.762H11.1744L11.3367 15.4942ZM6.66332 15.4942L6.50107 16.2265L6.50107 16.2265L6.66332 15.4942ZM6.66332 2.50579L6.50107 1.77355L6.50107 1.77355L6.66332 2.50579ZM11.3367 2.50579L11.1744 3.23803V3.23803L11.3367 2.50579ZM6.32292 15.4188L6.48517 14.6865H6.48517L6.32292 15.4188ZM11.6771 15.4188L11.8393 16.151L11.8393 16.151L11.6771 15.4188ZM11.6771 2.58121L11.8393 1.84897V1.84897L11.6771 2.58121ZM6.32292 2.58121L6.48517 3.31345H6.48517L6.32292 2.58121ZM6.48517 3.31345L6.82558 3.23802L6.50107 1.77355L6.16067 1.84898L6.48517 3.31345ZM11.1744 3.23803L11.5148 3.31345L11.8393 1.84897L11.4989 1.77355L11.1744 3.23803ZM11.5148 14.6865L11.1744 14.762L11.4989 16.2265L11.8393 16.151L11.5148 14.6865ZM6.82558 14.762L6.48517 14.6865L6.16066 16.151L6.50107 16.2265L6.82558 14.762ZM2.89194 11.1827C2.53602 9.74934 2.53602 8.25066 2.89194 6.81731L1.43615 6.45582C1.02128 8.12656 1.02128 9.87344 1.43615 11.5442L2.89194 11.1827ZM15.1081 6.81731C15.464 8.25066 15.464 9.74934 15.1081 11.1827L16.5639 11.5442C16.9787 9.87344 16.9787 8.12656 16.5639 6.45582L15.1081 6.81731ZM11.1744 14.762C9.74217 15.0793 8.25783 15.0793 6.82557 14.762L6.50107 16.2265C8.14707 16.5912 9.85293 16.5912 11.4989 16.2265L11.1744 14.762ZM6.82557 3.23802C8.25783 2.92066 9.74217 2.92066 11.1744 3.23803L11.4989 1.77355C9.85293 1.40882 8.14707 1.40882 6.50107 1.77355L6.82557 3.23802ZM6.48517 14.6865C4.71976 14.2954 3.32784 12.9382 2.89194 11.1827L1.43615 11.5442C2.00923 13.8521 3.83926 15.6366 6.16066 16.151L6.48517 14.6865ZM11.8393 16.151C14.1607 15.6366 15.9908 13.8521 16.5639 11.5442L15.1081 11.1827C14.6722 12.9382 13.2802 14.2954 11.5148 14.6865L11.8393 16.151ZM11.5148 3.31345C13.2802 3.70464 14.6722 5.06184 15.1081 6.81731L16.5639 6.45582C15.9908 4.14792 14.1607 2.36337 11.8393 1.84897L11.5148 3.31345ZM6.16067 1.84898C3.83926 2.36337 2.00923 4.14792 1.43615 6.45582L2.89194 6.81731C3.32784 5.06183 4.71977 3.70464 6.48517 3.31345L6.16067 1.84898Z"
                                        fill="#F5C042"
                                    />
                                    <path
                                        d="M2.16404 11.3634L2.89194 11.1827L2.16404 11.3634ZM2.16404 6.63656L2.89194 6.81731L2.16404 6.63656ZM15.836 6.63657L16.5639 6.45582L15.836 6.63657ZM15.1081 11.1827C15.0082 11.5847 15.2532 11.9915 15.6552 12.0913C16.0572 12.1912 16.464 11.9462 16.5639 11.5442L15.1081 11.1827ZM11.3367 15.4942L11.1744 14.762H11.1744L11.3367 15.4942ZM6.66332 15.4942L6.50107 16.2265L6.50107 16.2265L6.66332 15.4942ZM6.66332 2.50579L6.50107 1.77355L6.50107 1.77355L6.66332 2.50579ZM11.3367 2.50579L11.1744 3.23803V3.23803L11.3367 2.50579ZM6.32292 15.4188L6.48517 14.6865H6.48517L6.32292 15.4188ZM11.8393 16.151C12.2437 16.0614 12.4989 15.6609 12.4093 15.2565C12.3197 14.8521 11.9192 14.5969 11.5148 14.6865L11.8393 16.151ZM11.6771 2.58121L11.8393 1.84897V1.84897L11.6771 2.58121ZM6.32292 2.58121L6.48517 3.31345H6.48517L6.32292 2.58121ZM6.48517 3.31345L6.82558 3.23802L6.50107 1.77355L6.16067 1.84898L6.48517 3.31345ZM11.1744 3.23803L11.5148 3.31345L11.8393 1.84897L11.4989 1.77355L11.1744 3.23803ZM11.5148 14.6865L11.1744 14.762L11.4989 16.2265L11.8393 16.151L11.5148 14.6865ZM6.82558 14.762L6.48517 14.6865L6.16066 16.151L6.50107 16.2265L6.82558 14.762ZM2.89194 11.1827C2.53602 9.74934 2.53602 8.25066 2.89194 6.81731L1.43615 6.45582C1.02128 8.12656 1.02128 9.87344 1.43615 11.5442L2.89194 11.1827ZM15.1081 6.81731C15.464 8.25066 15.464 9.74934 15.1081 11.1827L16.5639 11.5442C16.9787 9.87344 16.9787 8.12656 16.5639 6.45582L15.1081 6.81731ZM11.1744 14.762C9.74217 15.0793 8.25783 15.0793 6.82557 14.762L6.50107 16.2265C8.14707 16.5912 9.85293 16.5912 11.4989 16.2265L11.1744 14.762ZM6.82557 3.23802C8.25783 2.92066 9.74217 2.92066 11.1744 3.23803L11.4989 1.77355C9.85293 1.40882 8.14707 1.40882 6.50107 1.77355L6.82557 3.23802ZM6.48517 14.6865C4.71976 14.2954 3.32784 12.9382 2.89194 11.1827L1.43615 11.5442C2.00923 13.8521 3.83926 15.6366 6.16066 16.151L6.48517 14.6865ZM11.5148 3.31345C13.2802 3.70464 14.6722 5.06184 15.1081 6.81731L16.5639 6.45582C15.9908 4.14792 14.1607 2.36337 11.8393 1.84897L11.5148 3.31345ZM6.16067 1.84898C3.83926 2.36337 2.00923 4.14792 1.43615 6.45582L2.89194 6.81731C3.32784 5.06183 4.71977 3.70464 6.48517 3.31345L6.16067 1.84898Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            </div>
                            <p>Email</p>
                        </a>
                        <a
                            class="btn-gray btn-gray-whatsapp left-btn"
                            :href="'https://wa.me/' + ownerdata.whatsapp"
                            v-if="!processing && !feedback && ownerdata.whatsapp != ''"
                        >
                            <div class="btn-gray-svg">
                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1157_542)">
                                <path d="M16.1512 2.76218C15.2801 1.88305 14.2428 1.18607 13.0997 0.711852C11.9565 0.237637 10.7305 -0.00432757 9.49287 5.858e-05C4.30706 5.858e-05 0.08075 4.22518 0.076 9.41218C0.076 11.0735 0.510625 12.6897 1.33119 14.1206L0 19.0001L4.99225 17.6914C6.37332 18.443 7.92054 18.837 9.49287 18.8374H9.49763C14.6846 18.8374 18.9098 14.6122 18.9145 9.4205C18.9157 8.18317 18.672 6.95784 18.1976 5.8151C17.7231 4.67236 17.0272 3.6348 16.15 2.76218H16.1512ZM9.49287 17.2437C8.09043 17.2442 6.71377 16.8668 5.50763 16.1512L5.22262 15.9802L2.261 16.7569L3.05187 13.8677L2.86663 13.5696C2.08265 12.3231 1.66802 10.88 1.67081 9.40743C1.67081 5.10156 5.18225 1.58893 9.49763 1.58893C10.5257 1.58709 11.544 1.78876 12.4937 2.18232C13.4435 2.57587 14.3059 3.15354 15.0314 3.882C15.7594 4.60762 16.3365 5.47019 16.7294 6.41996C17.1224 7.36973 17.3234 8.3879 17.3209 9.41575C17.3161 13.7371 13.8047 17.2437 9.49287 17.2437V17.2437ZM13.7857 11.3846C13.5518 11.2671 12.3963 10.6982 12.179 10.6175C11.9629 10.5403 11.8049 10.4999 11.6506 10.7351C11.4926 10.969 11.0414 11.5022 10.906 11.6554C10.7706 11.8133 10.6305 11.8311 10.3954 11.7147C10.1614 11.596 9.40263 11.349 8.50488 10.5451C7.80425 9.92162 7.33519 9.14975 7.19506 8.91581C7.05969 8.68068 7.182 8.55481 7.29956 8.43725C7.40287 8.33275 7.5335 8.16175 7.65106 8.02637C7.76981 7.891 7.809 7.79125 7.88619 7.6345C7.96337 7.47537 7.92656 7.34 7.86837 7.22243C7.809 7.10487 7.33994 5.94468 7.14162 5.47681C6.95162 5.01487 6.75806 5.079 6.61319 5.07306C6.47781 5.06475 6.31988 5.06475 6.16194 5.06475C6.04267 5.06771 5.9253 5.0953 5.8172 5.14577C5.7091 5.19625 5.6126 5.26852 5.53375 5.35806C5.31762 5.59318 4.71319 6.162 4.71319 7.32218C4.71319 8.48237 5.55631 9.59743 5.67506 9.75537C5.79144 9.91331 7.33044 12.2871 9.69237 13.3084C10.2505 13.5518 10.6899 13.6955 11.0331 13.8047C11.5971 13.9852 12.1066 13.9579 12.5127 13.8997C12.9639 13.8309 13.9033 13.3297 14.1016 12.7799C14.2963 12.2289 14.2963 11.7587 14.2369 11.6601C14.1788 11.5604 14.0208 11.5022 13.7857 11.3846V11.3846Z" fill="currentColor"/>
                                <path d="M14.0725 11.3199C13.8386 11.2023 12.6831 10.6335 12.4658 10.5528C12.2497 10.4756 12.0918 10.4352 11.9374 10.6703C11.7794 10.9043 11.3282 11.4374 11.1928 11.5906C11.0574 11.7486 10.9173 11.7664 10.6822 11.65C10.4482 11.5313 9.68944 11.2843 8.79169 10.4803C8.09106 9.85688 7.622 9.085 7.48187 8.85106C7.3465 8.61594 7.46881 8.49006 7.58637 8.3725C7.68969 8.268 7.82031 8.097 7.93787 7.96163C8.05662 7.82625 8.09581 7.7265 8.173 7.56975C8.25019 7.41063 8.21337 7.27525 8.15519 7.15769C8.09581 7.04012 7.62675 5.87994 7.42844 5.41206C7.23844 4.95013 7.04487 5.01425 6.9 5.00831C6.76462 5 6.60669 5 6.44875 5C6.32948 5.00296 6.21211 5.03055 6.10401 5.08103C5.99591 5.1315 5.89941 5.20377 5.82056 5.29331C5.60444 5.52844 5 6.09725 5 7.25744C5 8.41762 5.84312 9.53269 5.96187 9.69063C6.07825 9.84856 7.61725 12.2224 9.97919 13.2436C10.5373 13.4871 10.9767 13.6308 11.3199 13.74C11.8839 13.9205 12.3934 13.8932 12.7995 13.835C13.2507 13.7661 14.1901 13.265 14.3884 12.7152C14.5831 12.1642 14.5831 11.6939 14.5237 11.5954C14.4656 11.4956 14.3076 11.4374 14.0725 11.3199Z" fill="#F5C042"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1157_542">
                                <rect width="19" height="19" fill="white"/>
                                </clipPath>
                                </defs>
                                </svg>
                            </div>
                            <p>WhatsApp</p>
                        </a>
                    </div>

                    <div v-if="processing && !feedback">
                        <img src="@/assets/gifs/barkbadge-loading-250px.gif" />
                    </div>
                    <div class="" v-else-if="!processing && feedback">
                        <p>{{ feedback }}</p>
                    </div>
                </div>
                <div v-else>
                    <div class="hidden_contact">
                        <img src="@/assets/svg/login/lock.svg" />
                        <p>This contact is hidden.</p>
                    </div>
                </div>
            </div>
        </PetButtonDropDown>

        <!-- <pre>{{ownerdata.contacts}}</pre> -->
        <div class="space-12"></div>
        <div v-for="(contact,idx) in emerygencyContacts" :key="idx" >
        <div v-if="contact">
        <PetButtonDropDown
            :expanded="true"
            :hide-expand="!contact.phone && !contact.email && !contact.whatsapp"
            v-if="contact"
            :address_privacy="
                !(pet_data.settings_privacy && pet_data.settings_privacy.showContact)
            "
            :img_src="contact.photo"
            :name="contact.fname + ' ' + contact.lname"
            :colored_text="getLabelData(contact.label)"
        >
            <div>
                <div
                    class="pet-content-group"
                    v-if="pet_data.settings_privacy && pet_data.settings_privacy.showContact"
                >
                    <div class="coalition-text">
                        <a
                            class="btn-gray left-btn"
                            :href="'tel:' + contact.phone"
                            v-if="!processing && !feedback && contact.phone"
                        >
                            <div class="btn-gray-svg">
                                <svg
                                    height="18"
                                    width="18"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M7.58337 1.89724C8.84495 1.53778 10.2333 1.83553 11.1989 2.80112C12.1645 3.76672 12.4623 5.15509 12.1028 6.41667M8.71323 3.47904C9.16382 3.38929 9.68282 3.54474 10.0691 3.93098C10.4553 4.31722 10.6107 4.83621 10.521 5.28681"
                                        stroke="#F5C042"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M8.84643 12.182C9.36067 12.2727 9.88933 12.2727 10.4036 12.182C11.2301 12.0364 11.8958 11.4815 12.1252 10.7471L12.1738 10.5913C12.2244 10.4294 12.25 10.2619 12.25 10.0936C12.25 9.35157 11.5864 8.75 10.7677 8.75H8.48229C7.66364 8.75 7 9.35157 7 10.0936C7 10.2619 7.02564 10.4294 7.0762 10.5913L7.12484 10.7471C7.35416 11.4815 8.01991 12.0364 8.84643 12.182ZM8.84643 12.182C5.27447 11.5202 2.4798 8.72553 1.81796 5.15357M1.81796 5.15357C1.72735 4.63933 1.72735 4.11067 1.81796 3.59644C1.9636 2.76991 2.51851 2.10416 3.25291 1.87484L3.40868 1.8262C3.5706 1.77564 3.73807 1.75 3.90635 1.75C4.64843 1.75 5.25 2.41364 5.25 3.23229L5.25 5.51771C5.25 6.33636 4.64843 7 3.90635 7C3.73807 7 3.5706 6.97436 3.40868 6.9238L3.2529 6.87516C2.51851 6.64584 1.9636 5.98009 1.81796 5.15357Z"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                    />
                                </svg>
                            </div>
                            <p>Phone</p>
                        </a>

                        <a
                            class="btn-gray right-btn"
                            :href="'mailto:' + contact.email"
                            v-if="!processing && !feedback && contact.email"
                        >
                            <div class="btn-gray-svg">
                                <svg
                                    height="18"
                                    width="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M3.66255 4.26505C3.32552 4.02426 2.8571 4.10228 2.61631 4.43931C2.37552 4.77635 2.45354 5.24477 2.79057 5.48556L3.66255 4.26505ZM7.56173 7.97253L7.12573 8.58279L7.56173 7.97253ZM10.438 7.97253L10.002 7.36228L10.438 7.97253ZM15.2092 5.48556C15.5462 5.24477 15.6242 4.77635 15.3834 4.43931C15.1426 4.10228 14.6742 4.02426 14.3372 4.26505L15.2092 5.48556ZM2.79057 5.48556L7.12573 8.58279L7.99772 7.36228L3.66255 4.26505L2.79057 5.48556ZM10.874 8.58279L15.2092 5.48556L14.3372 4.26505L10.002 7.36228L10.874 8.58279ZM7.12573 8.58279C8.24683 9.38375 9.75291 9.38375 10.874 8.58279L10.002 7.36228C9.40252 7.79058 8.59722 7.79058 7.99772 7.36228L7.12573 8.58279Z"
                                        fill="#F5C042"
                                    />
                                    <path
                                        d="M2.16404 11.3634L2.89194 11.1827L2.16404 11.3634ZM2.16404 6.63656L2.89194 6.81731L2.16404 6.63656ZM15.836 6.63657L16.5639 6.45582L15.836 6.63657ZM15.836 11.3634L16.5639 11.5442L15.836 11.3634ZM11.3367 15.4942L11.1744 14.762H11.1744L11.3367 15.4942ZM6.66332 15.4942L6.50107 16.2265L6.50107 16.2265L6.66332 15.4942ZM6.66332 2.50579L6.50107 1.77355L6.50107 1.77355L6.66332 2.50579ZM11.3367 2.50579L11.1744 3.23803V3.23803L11.3367 2.50579ZM6.32292 15.4188L6.48517 14.6865H6.48517L6.32292 15.4188ZM11.6771 15.4188L11.8393 16.151L11.8393 16.151L11.6771 15.4188ZM11.6771 2.58121L11.8393 1.84897V1.84897L11.6771 2.58121ZM6.32292 2.58121L6.48517 3.31345H6.48517L6.32292 2.58121ZM6.48517 3.31345L6.82558 3.23802L6.50107 1.77355L6.16067 1.84898L6.48517 3.31345ZM11.1744 3.23803L11.5148 3.31345L11.8393 1.84897L11.4989 1.77355L11.1744 3.23803ZM11.5148 14.6865L11.1744 14.762L11.4989 16.2265L11.8393 16.151L11.5148 14.6865ZM6.82558 14.762L6.48517 14.6865L6.16066 16.151L6.50107 16.2265L6.82558 14.762ZM2.89194 11.1827C2.53602 9.74934 2.53602 8.25066 2.89194 6.81731L1.43615 6.45582C1.02128 8.12656 1.02128 9.87344 1.43615 11.5442L2.89194 11.1827ZM15.1081 6.81731C15.464 8.25066 15.464 9.74934 15.1081 11.1827L16.5639 11.5442C16.9787 9.87344 16.9787 8.12656 16.5639 6.45582L15.1081 6.81731ZM11.1744 14.762C9.74217 15.0793 8.25783 15.0793 6.82557 14.762L6.50107 16.2265C8.14707 16.5912 9.85293 16.5912 11.4989 16.2265L11.1744 14.762ZM6.82557 3.23802C8.25783 2.92066 9.74217 2.92066 11.1744 3.23803L11.4989 1.77355C9.85293 1.40882 8.14707 1.40882 6.50107 1.77355L6.82557 3.23802ZM6.48517 14.6865C4.71976 14.2954 3.32784 12.9382 2.89194 11.1827L1.43615 11.5442C2.00923 13.8521 3.83926 15.6366 6.16066 16.151L6.48517 14.6865ZM11.8393 16.151C14.1607 15.6366 15.9908 13.8521 16.5639 11.5442L15.1081 11.1827C14.6722 12.9382 13.2802 14.2954 11.5148 14.6865L11.8393 16.151ZM11.5148 3.31345C13.2802 3.70464 14.6722 5.06184 15.1081 6.81731L16.5639 6.45582C15.9908 4.14792 14.1607 2.36337 11.8393 1.84897L11.5148 3.31345ZM6.16067 1.84898C3.83926 2.36337 2.00923 4.14792 1.43615 6.45582L2.89194 6.81731C3.32784 5.06183 4.71977 3.70464 6.48517 3.31345L6.16067 1.84898Z"
                                        fill="#F5C042"
                                    />
                                    <path
                                        d="M2.16404 11.3634L2.89194 11.1827L2.16404 11.3634ZM2.16404 6.63656L2.89194 6.81731L2.16404 6.63656ZM15.836 6.63657L16.5639 6.45582L15.836 6.63657ZM15.1081 11.1827C15.0082 11.5847 15.2532 11.9915 15.6552 12.0913C16.0572 12.1912 16.464 11.9462 16.5639 11.5442L15.1081 11.1827ZM11.3367 15.4942L11.1744 14.762H11.1744L11.3367 15.4942ZM6.66332 15.4942L6.50107 16.2265L6.50107 16.2265L6.66332 15.4942ZM6.66332 2.50579L6.50107 1.77355L6.50107 1.77355L6.66332 2.50579ZM11.3367 2.50579L11.1744 3.23803V3.23803L11.3367 2.50579ZM6.32292 15.4188L6.48517 14.6865H6.48517L6.32292 15.4188ZM11.8393 16.151C12.2437 16.0614 12.4989 15.6609 12.4093 15.2565C12.3197 14.8521 11.9192 14.5969 11.5148 14.6865L11.8393 16.151ZM11.6771 2.58121L11.8393 1.84897V1.84897L11.6771 2.58121ZM6.32292 2.58121L6.48517 3.31345H6.48517L6.32292 2.58121ZM6.48517 3.31345L6.82558 3.23802L6.50107 1.77355L6.16067 1.84898L6.48517 3.31345ZM11.1744 3.23803L11.5148 3.31345L11.8393 1.84897L11.4989 1.77355L11.1744 3.23803ZM11.5148 14.6865L11.1744 14.762L11.4989 16.2265L11.8393 16.151L11.5148 14.6865ZM6.82558 14.762L6.48517 14.6865L6.16066 16.151L6.50107 16.2265L6.82558 14.762ZM2.89194 11.1827C2.53602 9.74934 2.53602 8.25066 2.89194 6.81731L1.43615 6.45582C1.02128 8.12656 1.02128 9.87344 1.43615 11.5442L2.89194 11.1827ZM15.1081 6.81731C15.464 8.25066 15.464 9.74934 15.1081 11.1827L16.5639 11.5442C16.9787 9.87344 16.9787 8.12656 16.5639 6.45582L15.1081 6.81731ZM11.1744 14.762C9.74217 15.0793 8.25783 15.0793 6.82557 14.762L6.50107 16.2265C8.14707 16.5912 9.85293 16.5912 11.4989 16.2265L11.1744 14.762ZM6.82557 3.23802C8.25783 2.92066 9.74217 2.92066 11.1744 3.23803L11.4989 1.77355C9.85293 1.40882 8.14707 1.40882 6.50107 1.77355L6.82557 3.23802ZM6.48517 14.6865C4.71976 14.2954 3.32784 12.9382 2.89194 11.1827L1.43615 11.5442C2.00923 13.8521 3.83926 15.6366 6.16066 16.151L6.48517 14.6865ZM11.5148 3.31345C13.2802 3.70464 14.6722 5.06184 15.1081 6.81731L16.5639 6.45582C15.9908 4.14792 14.1607 2.36337 11.8393 1.84897L11.5148 3.31345ZM6.16067 1.84898C3.83926 2.36337 2.00923 4.14792 1.43615 6.45582L2.89194 6.81731C3.32784 5.06183 4.71977 3.70464 6.48517 3.31345L6.16067 1.84898Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            </div>
                            <p>Email</p>
                        </a>
                        <a
                            class="btn-gray btn-gray-whatsapp left-btn"
                            :href="'https://wa.me/' + contact.whatsapp"
                            v-if="!processing && !feedback && contact.whatsapp"
                        >
                            <div class="btn-gray-svg">
                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1157_542)">
                                <path d="M16.1512 2.76218C15.2801 1.88305 14.2428 1.18607 13.0997 0.711852C11.9565 0.237637 10.7305 -0.00432757 9.49287 5.858e-05C4.30706 5.858e-05 0.08075 4.22518 0.076 9.41218C0.076 11.0735 0.510625 12.6897 1.33119 14.1206L0 19.0001L4.99225 17.6914C6.37332 18.443 7.92054 18.837 9.49287 18.8374H9.49763C14.6846 18.8374 18.9098 14.6122 18.9145 9.4205C18.9157 8.18317 18.672 6.95784 18.1976 5.8151C17.7231 4.67236 17.0272 3.6348 16.15 2.76218H16.1512ZM9.49287 17.2437C8.09043 17.2442 6.71377 16.8668 5.50763 16.1512L5.22262 15.9802L2.261 16.7569L3.05187 13.8677L2.86663 13.5696C2.08265 12.3231 1.66802 10.88 1.67081 9.40743C1.67081 5.10156 5.18225 1.58893 9.49763 1.58893C10.5257 1.58709 11.544 1.78876 12.4937 2.18232C13.4435 2.57587 14.3059 3.15354 15.0314 3.882C15.7594 4.60762 16.3365 5.47019 16.7294 6.41996C17.1224 7.36973 17.3234 8.3879 17.3209 9.41575C17.3161 13.7371 13.8047 17.2437 9.49287 17.2437V17.2437ZM13.7857 11.3846C13.5518 11.2671 12.3963 10.6982 12.179 10.6175C11.9629 10.5403 11.8049 10.4999 11.6506 10.7351C11.4926 10.969 11.0414 11.5022 10.906 11.6554C10.7706 11.8133 10.6305 11.8311 10.3954 11.7147C10.1614 11.596 9.40263 11.349 8.50488 10.5451C7.80425 9.92162 7.33519 9.14975 7.19506 8.91581C7.05969 8.68068 7.182 8.55481 7.29956 8.43725C7.40287 8.33275 7.5335 8.16175 7.65106 8.02637C7.76981 7.891 7.809 7.79125 7.88619 7.6345C7.96337 7.47537 7.92656 7.34 7.86837 7.22243C7.809 7.10487 7.33994 5.94468 7.14162 5.47681C6.95162 5.01487 6.75806 5.079 6.61319 5.07306C6.47781 5.06475 6.31988 5.06475 6.16194 5.06475C6.04267 5.06771 5.9253 5.0953 5.8172 5.14577C5.7091 5.19625 5.6126 5.26852 5.53375 5.35806C5.31762 5.59318 4.71319 6.162 4.71319 7.32218C4.71319 8.48237 5.55631 9.59743 5.67506 9.75537C5.79144 9.91331 7.33044 12.2871 9.69237 13.3084C10.2505 13.5518 10.6899 13.6955 11.0331 13.8047C11.5971 13.9852 12.1066 13.9579 12.5127 13.8997C12.9639 13.8309 13.9033 13.3297 14.1016 12.7799C14.2963 12.2289 14.2963 11.7587 14.2369 11.6601C14.1788 11.5604 14.0208 11.5022 13.7857 11.3846V11.3846Z" fill="currentColor"/>
                                <path d="M14.0725 11.3199C13.8386 11.2023 12.6831 10.6335 12.4658 10.5528C12.2497 10.4756 12.0918 10.4352 11.9374 10.6703C11.7794 10.9043 11.3282 11.4374 11.1928 11.5906C11.0574 11.7486 10.9173 11.7664 10.6822 11.65C10.4482 11.5313 9.68944 11.2843 8.79169 10.4803C8.09106 9.85688 7.622 9.085 7.48187 8.85106C7.3465 8.61594 7.46881 8.49006 7.58637 8.3725C7.68969 8.268 7.82031 8.097 7.93787 7.96163C8.05662 7.82625 8.09581 7.7265 8.173 7.56975C8.25019 7.41063 8.21337 7.27525 8.15519 7.15769C8.09581 7.04012 7.62675 5.87994 7.42844 5.41206C7.23844 4.95013 7.04487 5.01425 6.9 5.00831C6.76462 5 6.60669 5 6.44875 5C6.32948 5.00296 6.21211 5.03055 6.10401 5.08103C5.99591 5.1315 5.89941 5.20377 5.82056 5.29331C5.60444 5.52844 5 6.09725 5 7.25744C5 8.41762 5.84312 9.53269 5.96187 9.69063C6.07825 9.84856 7.61725 12.2224 9.97919 13.2436C10.5373 13.4871 10.9767 13.6308 11.3199 13.74C11.8839 13.9205 12.3934 13.8932 12.7995 13.835C13.2507 13.7661 14.1901 13.265 14.3884 12.7152C14.5831 12.1642 14.5831 11.6939 14.5237 11.5954C14.4656 11.4956 14.3076 11.4374 14.0725 11.3199Z" fill="#F5C042"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1157_542">
                                <rect width="19" height="19" fill="white"/>
                                </clipPath>
                                </defs>
                                </svg>
                            </div>
                            <p>WhatsApp</p>
                        </a>
                    </div>

                    <div v-if="processing && !feedback">
                        <img src="@/assets/gifs/barkbadge-loading-250px.gif" />
                    </div>
                    <div class="" v-else-if="!processing && feedback">
                        <p>{{ feedback }}</p>
                    </div>
                </div>
                <div v-else>
                    <div class="hidden_contact">
                        <img src="@/assets/svg/login/lock.svg" />
                        <p>This contact is hidden.</p>
                    </div>
                </div>
            </div>
        </PetButtonDropDown>
        <div class="space-12" ></div>
        </div>
        </div>

        <PetButtonDropDown
            :expanded="true"
            :hide-expand="!pet_data.veternarian.phone && !pet_data.veternarian.email"
            v-if="pet_data.displayVetCard && pet_data.veternarian && pet_data.settings_privacy && pet_data.settings_privacy.showContact && pet_data.settings_privacy.showHealth"
            :address_privacy="false"
            :img_src="require('@/assets/svg/pet-card-icon/vet-contact.svg')"
            :name="'Veterinarian Contact'"
            :second_name="pet_data.veternarian.name"
            :gray_text="userAddressFmt(pet_data.veternarian.address)"
        >
            <div>
                <div
                    class="pet-content-group"
                >
                    <div class="coalition-text">
                        <a
                            class="btn-gray left-btn"
                            :href="'tel:' + pet_data.veternarian.phone"
                            v-if="!processing && !feedback && pet_data.veternarian.phone"
                        >
                            <div class="btn-gray-svg">
                                <svg
                                    height="18"
                                    width="18"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M7.58337 1.89724C8.84495 1.53778 10.2333 1.83553 11.1989 2.80112C12.1645 3.76672 12.4623 5.15509 12.1028 6.41667M8.71323 3.47904C9.16382 3.38929 9.68282 3.54474 10.0691 3.93098C10.4553 4.31722 10.6107 4.83621 10.521 5.28681"
                                        stroke="#F5C042"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M8.84643 12.182C9.36067 12.2727 9.88933 12.2727 10.4036 12.182C11.2301 12.0364 11.8958 11.4815 12.1252 10.7471L12.1738 10.5913C12.2244 10.4294 12.25 10.2619 12.25 10.0936C12.25 9.35157 11.5864 8.75 10.7677 8.75H8.48229C7.66364 8.75 7 9.35157 7 10.0936C7 10.2619 7.02564 10.4294 7.0762 10.5913L7.12484 10.7471C7.35416 11.4815 8.01991 12.0364 8.84643 12.182ZM8.84643 12.182C5.27447 11.5202 2.4798 8.72553 1.81796 5.15357M1.81796 5.15357C1.72735 4.63933 1.72735 4.11067 1.81796 3.59644C1.9636 2.76991 2.51851 2.10416 3.25291 1.87484L3.40868 1.8262C3.5706 1.77564 3.73807 1.75 3.90635 1.75C4.64843 1.75 5.25 2.41364 5.25 3.23229L5.25 5.51771C5.25 6.33636 4.64843 7 3.90635 7C3.73807 7 3.5706 6.97436 3.40868 6.9238L3.2529 6.87516C2.51851 6.64584 1.9636 5.98009 1.81796 5.15357Z"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                    />
                                </svg>
                            </div>
                            <p>Phone</p>
                        </a>

                        <a
                            class="btn-gray right-btn"
                            :href="'mailto:' + pet_data.veternarian.email"
                            v-if="!processing && !feedback && pet_data.veternarian.email"
                        >
                            <div class="btn-gray-svg">
                                <svg
                                    height="18"
                                    width="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M3.66255 4.26505C3.32552 4.02426 2.8571 4.10228 2.61631 4.43931C2.37552 4.77635 2.45354 5.24477 2.79057 5.48556L3.66255 4.26505ZM7.56173 7.97253L7.12573 8.58279L7.56173 7.97253ZM10.438 7.97253L10.002 7.36228L10.438 7.97253ZM15.2092 5.48556C15.5462 5.24477 15.6242 4.77635 15.3834 4.43931C15.1426 4.10228 14.6742 4.02426 14.3372 4.26505L15.2092 5.48556ZM2.79057 5.48556L7.12573 8.58279L7.99772 7.36228L3.66255 4.26505L2.79057 5.48556ZM10.874 8.58279L15.2092 5.48556L14.3372 4.26505L10.002 7.36228L10.874 8.58279ZM7.12573 8.58279C8.24683 9.38375 9.75291 9.38375 10.874 8.58279L10.002 7.36228C9.40252 7.79058 8.59722 7.79058 7.99772 7.36228L7.12573 8.58279Z"
                                        fill="#F5C042"
                                    />
                                    <path
                                        d="M2.16404 11.3634L2.89194 11.1827L2.16404 11.3634ZM2.16404 6.63656L2.89194 6.81731L2.16404 6.63656ZM15.836 6.63657L16.5639 6.45582L15.836 6.63657ZM15.836 11.3634L16.5639 11.5442L15.836 11.3634ZM11.3367 15.4942L11.1744 14.762H11.1744L11.3367 15.4942ZM6.66332 15.4942L6.50107 16.2265L6.50107 16.2265L6.66332 15.4942ZM6.66332 2.50579L6.50107 1.77355L6.50107 1.77355L6.66332 2.50579ZM11.3367 2.50579L11.1744 3.23803V3.23803L11.3367 2.50579ZM6.32292 15.4188L6.48517 14.6865H6.48517L6.32292 15.4188ZM11.6771 15.4188L11.8393 16.151L11.8393 16.151L11.6771 15.4188ZM11.6771 2.58121L11.8393 1.84897V1.84897L11.6771 2.58121ZM6.32292 2.58121L6.48517 3.31345H6.48517L6.32292 2.58121ZM6.48517 3.31345L6.82558 3.23802L6.50107 1.77355L6.16067 1.84898L6.48517 3.31345ZM11.1744 3.23803L11.5148 3.31345L11.8393 1.84897L11.4989 1.77355L11.1744 3.23803ZM11.5148 14.6865L11.1744 14.762L11.4989 16.2265L11.8393 16.151L11.5148 14.6865ZM6.82558 14.762L6.48517 14.6865L6.16066 16.151L6.50107 16.2265L6.82558 14.762ZM2.89194 11.1827C2.53602 9.74934 2.53602 8.25066 2.89194 6.81731L1.43615 6.45582C1.02128 8.12656 1.02128 9.87344 1.43615 11.5442L2.89194 11.1827ZM15.1081 6.81731C15.464 8.25066 15.464 9.74934 15.1081 11.1827L16.5639 11.5442C16.9787 9.87344 16.9787 8.12656 16.5639 6.45582L15.1081 6.81731ZM11.1744 14.762C9.74217 15.0793 8.25783 15.0793 6.82557 14.762L6.50107 16.2265C8.14707 16.5912 9.85293 16.5912 11.4989 16.2265L11.1744 14.762ZM6.82557 3.23802C8.25783 2.92066 9.74217 2.92066 11.1744 3.23803L11.4989 1.77355C9.85293 1.40882 8.14707 1.40882 6.50107 1.77355L6.82557 3.23802ZM6.48517 14.6865C4.71976 14.2954 3.32784 12.9382 2.89194 11.1827L1.43615 11.5442C2.00923 13.8521 3.83926 15.6366 6.16066 16.151L6.48517 14.6865ZM11.8393 16.151C14.1607 15.6366 15.9908 13.8521 16.5639 11.5442L15.1081 11.1827C14.6722 12.9382 13.2802 14.2954 11.5148 14.6865L11.8393 16.151ZM11.5148 3.31345C13.2802 3.70464 14.6722 5.06184 15.1081 6.81731L16.5639 6.45582C15.9908 4.14792 14.1607 2.36337 11.8393 1.84897L11.5148 3.31345ZM6.16067 1.84898C3.83926 2.36337 2.00923 4.14792 1.43615 6.45582L2.89194 6.81731C3.32784 5.06183 4.71977 3.70464 6.48517 3.31345L6.16067 1.84898Z"
                                        fill="#F5C042"
                                    />
                                    <path
                                        d="M2.16404 11.3634L2.89194 11.1827L2.16404 11.3634ZM2.16404 6.63656L2.89194 6.81731L2.16404 6.63656ZM15.836 6.63657L16.5639 6.45582L15.836 6.63657ZM15.1081 11.1827C15.0082 11.5847 15.2532 11.9915 15.6552 12.0913C16.0572 12.1912 16.464 11.9462 16.5639 11.5442L15.1081 11.1827ZM11.3367 15.4942L11.1744 14.762H11.1744L11.3367 15.4942ZM6.66332 15.4942L6.50107 16.2265L6.50107 16.2265L6.66332 15.4942ZM6.66332 2.50579L6.50107 1.77355L6.50107 1.77355L6.66332 2.50579ZM11.3367 2.50579L11.1744 3.23803V3.23803L11.3367 2.50579ZM6.32292 15.4188L6.48517 14.6865H6.48517L6.32292 15.4188ZM11.8393 16.151C12.2437 16.0614 12.4989 15.6609 12.4093 15.2565C12.3197 14.8521 11.9192 14.5969 11.5148 14.6865L11.8393 16.151ZM11.6771 2.58121L11.8393 1.84897V1.84897L11.6771 2.58121ZM6.32292 2.58121L6.48517 3.31345H6.48517L6.32292 2.58121ZM6.48517 3.31345L6.82558 3.23802L6.50107 1.77355L6.16067 1.84898L6.48517 3.31345ZM11.1744 3.23803L11.5148 3.31345L11.8393 1.84897L11.4989 1.77355L11.1744 3.23803ZM11.5148 14.6865L11.1744 14.762L11.4989 16.2265L11.8393 16.151L11.5148 14.6865ZM6.82558 14.762L6.48517 14.6865L6.16066 16.151L6.50107 16.2265L6.82558 14.762ZM2.89194 11.1827C2.53602 9.74934 2.53602 8.25066 2.89194 6.81731L1.43615 6.45582C1.02128 8.12656 1.02128 9.87344 1.43615 11.5442L2.89194 11.1827ZM15.1081 6.81731C15.464 8.25066 15.464 9.74934 15.1081 11.1827L16.5639 11.5442C16.9787 9.87344 16.9787 8.12656 16.5639 6.45582L15.1081 6.81731ZM11.1744 14.762C9.74217 15.0793 8.25783 15.0793 6.82557 14.762L6.50107 16.2265C8.14707 16.5912 9.85293 16.5912 11.4989 16.2265L11.1744 14.762ZM6.82557 3.23802C8.25783 2.92066 9.74217 2.92066 11.1744 3.23803L11.4989 1.77355C9.85293 1.40882 8.14707 1.40882 6.50107 1.77355L6.82557 3.23802ZM6.48517 14.6865C4.71976 14.2954 3.32784 12.9382 2.89194 11.1827L1.43615 11.5442C2.00923 13.8521 3.83926 15.6366 6.16066 16.151L6.48517 14.6865ZM11.5148 3.31345C13.2802 3.70464 14.6722 5.06184 15.1081 6.81731L16.5639 6.45582C15.9908 4.14792 14.1607 2.36337 11.8393 1.84897L11.5148 3.31345ZM6.16067 1.84898C3.83926 2.36337 2.00923 4.14792 1.43615 6.45582L2.89194 6.81731C3.32784 5.06183 4.71977 3.70464 6.48517 3.31345L6.16067 1.84898Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            </div>
                            <p>Email</p>
                        </a>

                        <a
                            class="btn-gray left-btn"
                            :href="pet_data.veternarian.website"
                            v-if="
                                pet_data.veternarian.website &&
                                !processing &&
                                !feedback
                            "
                        >
                            <div class="btn-gray-svg">
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M2.51466 6.71282C3.00328 4.62975 4.62976 3.00328 6.71282 2.51466C8.21719 2.16178 9.78281 2.16178 11.2872 2.51466C13.3702 3.00328 14.9967 4.62976 15.4853 6.71283C15.8382 8.21719 15.8382 9.78281 15.4853 11.2872C14.9967 13.3702 13.3702 14.9967 11.2872 15.4853C9.78281 15.8382 8.21719 15.8382 6.71283 15.4853C4.62976 14.9967 3.00328 13.3702 2.51466 11.2872C2.16178 9.78281 2.16178 8.21719 2.51466 6.71282Z"
                                        stroke="#F5C042"
                                        stroke-width="1.5"
                                    />
                                    <path
                                        d="M15.4853 6.71283C14.9967 4.62976 13.3702 3.00328 11.2872 2.51466C9.78281 2.16178 8.21719 2.16178 6.71282 2.51466C4.62976 3.00328 3.00328 4.62975 2.51466 6.71282C2.16178 8.21719 2.16178 9.78281 2.51466 11.2872C3.00328 13.3702 4.62976 14.9967 6.71283 15.4853C8.21719 15.8382 9.78281 15.8382 11.2872 15.4853"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                    />
                                    <path
                                        d="M7.63639 8.4719C7.78885 8.09074 8.09087 7.78873 8.47202 7.63627L10.0003 7.02495C10.6125 6.78006 11.2201 7.38762 10.9752 7.99985L10.3639 9.52814C10.2114 9.9093 9.90942 10.2113 9.52826 10.3638L7.99998 10.9751C7.38774 11.22 6.78018 10.6124 7.02508 10.0002L7.63639 8.4719Z"
                                        stroke="#F5C042"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                            <p>Website</p>
                        </a>

                        <a
                            class="btn-gray right-btn"
                            :href="`geo:0,0?q=${userAddressFmt(
                                pet_data.veternarian.address
                            )}`"
                            v-if="!processing && !feedback"
                        >
                            <div class="btn-gray-svg">
                                <svg
                                    width="17"
                                    height="18"
                                    viewBox="0 0 17 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M6.02124 1.75142C6.33864 1.43394 6.71548 1.18209 7.13022 1.01026C7.54497 0.838438 7.9895 0.75 8.43843 0.75C8.88736 0.75 9.33189 0.838438 9.74664 1.01026C10.1614 1.18209 10.5382 1.43394 10.8556 1.75142L15.6886 6.58579C16.3294 7.22676 16.6894 8.09597 16.6894 9.0023C16.6894 9.90862 16.3294 10.7778 15.6886 11.4188L10.8556 16.2532C10.5382 16.5707 10.1614 16.8225 9.74664 16.9943C9.33189 17.1662 8.88736 17.2546 8.43843 17.2546C7.9895 17.2546 7.54497 17.1662 7.13022 16.9943C6.71548 16.8225 6.33864 16.5707 6.02124 16.2532L1.18823 11.4188C0.547465 10.7778 0.1875 9.90862 0.1875 9.0023C0.1875 8.09597 0.547465 7.22676 1.18823 6.58579L6.02124 1.75142ZM9.88902 2.71802C9.69857 2.52745 9.47243 2.37627 9.22353 2.27313C8.97464 2.16998 8.70785 2.1169 8.43843 2.1169C8.16901 2.1169 7.90222 2.16998 7.65333 2.27313C7.40443 2.37627 7.17829 2.52745 6.98784 2.71802L2.15484 7.5524C1.77037 7.93697 1.5544 8.4585 1.5544 9.0023C1.5544 9.54609 1.77037 10.0676 2.15484 10.4522L6.98784 15.2866C7.17829 15.4771 7.40443 15.6283 7.65333 15.7315C7.90222 15.8346 8.16901 15.8877 8.43843 15.8877C8.70785 15.8877 8.97464 15.8346 9.22353 15.7315C9.47243 15.6283 9.69857 15.4771 9.88902 15.2866L14.722 10.4522C15.1065 10.0676 15.3225 9.54609 15.3225 9.0023C15.3225 8.4585 15.1065 7.93697 14.722 7.5524L9.88902 2.71802ZM8.63804 4.41743C8.76623 4.28928 8.94008 4.21729 9.12134 4.21729C9.30261 4.21729 9.47645 4.28928 9.60464 4.41743L11.6554 6.46822C11.7836 6.59641 11.8556 6.77025 11.8556 6.95152C11.8556 7.13278 11.7836 7.30662 11.6554 7.43482L9.60464 9.4856C9.54158 9.55089 9.46615 9.60297 9.38275 9.63879C9.29935 9.67462 9.20965 9.69348 9.11888 9.69427C9.02811 9.69505 8.9381 9.67776 8.85409 9.64339C8.77007 9.60901 8.69375 9.55826 8.62957 9.49407C8.56538 9.42989 8.51462 9.35356 8.48025 9.26955C8.44588 9.18554 8.42858 9.09552 8.42937 9.00476C8.43016 8.91399 8.44902 8.82429 8.48484 8.74089C8.52067 8.65749 8.57275 8.58206 8.63804 8.519L9.52261 7.63443H7.75484C7.57354 7.63443 7.39966 7.70645 7.27146 7.83465C7.14326 7.96285 7.07124 8.13672 7.07124 8.31802V11.736C7.07124 11.9173 6.99922 12.0912 6.87102 12.2194C6.74282 12.3476 6.56895 12.4196 6.38765 12.4196C6.20635 12.4196 6.03247 12.3476 5.90427 12.2194C5.77608 12.0912 5.70405 11.9173 5.70405 11.736V8.31802C5.70405 7.77412 5.92012 7.25249 6.30471 6.8679C6.68931 6.4833 7.21094 6.26724 7.75484 6.26724H9.52261L8.63804 5.38404C8.50988 5.25584 8.43789 5.082 8.43789 4.90074C8.43789 4.71947 8.50988 4.54563 8.63804 4.41743Z"
                                        fill="currentColor"
                                    />
                                    <path
                                        d="M8.63809 4.41737C8.76628 4.28922 8.94012 4.21722 9.12139 4.21722C9.30265 4.21722 9.47649 4.28922 9.60469 4.41737L11.6555 6.46815C11.7836 6.59635 11.8556 6.77019 11.8556 6.95145C11.8556 7.13272 11.7836 7.30656 11.6555 7.43475L9.60469 9.48554C9.54163 9.55083 9.4662 9.6029 9.3828 9.63873C9.2994 9.67456 9.20969 9.69341 9.11893 9.6942C9.02816 9.69499 8.93814 9.67769 8.85413 9.64332C8.77012 9.60895 8.6938 9.55819 8.62961 9.49401C8.56543 9.42982 8.51467 9.3535 8.4803 9.26949C8.44593 9.18548 8.42863 9.09546 8.42942 9.00469C8.43021 8.91393 8.44906 8.82423 8.48489 8.74083C8.52072 8.65742 8.5728 8.58199 8.63809 8.51893L9.52266 7.63436H7.75488C7.57358 7.63436 7.39971 7.70638 7.27151 7.83458C7.14331 7.96278 7.07129 8.13666 7.07129 8.31796V11.7359C7.07129 11.9172 6.99927 12.0911 6.87107 12.2193C6.74287 12.3475 6.569 12.4195 6.3877 12.4195C6.20639 12.4195 6.03252 12.3475 5.90432 12.2193C5.77612 12.0911 5.7041 11.9172 5.7041 11.7359V8.31796C5.7041 7.77406 5.92017 7.25243 6.30476 6.86784C6.68936 6.48324 7.21098 6.26718 7.75488 6.26718H9.52266L8.63809 5.38397C8.50993 5.25578 8.43794 5.08194 8.43794 4.90067C8.43794 4.71941 8.50993 4.54556 8.63809 4.41737Z"
                                        fill="#F5C042"
                                    />
                                </svg>
                            </div>
                            <p>Directions</p>
                        </a>
                    </div>
                    <div v-if="processing && !feedback">
                        <img src="@/assets/gifs/barkbadge-loading-250px.gif" />
                    </div>
                    <div class="" v-else-if="!processing && feedback">
                        <p>{{ feedback }}</p>
                    </div>
                </div>
            </div>
        </PetButtonDropDown>
    </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import PetButtonDropDown from "@/petprofile/components/pet/tabs/PetButtonDropDown";

export default {
    name: "ScannedContact",
    props: ["owner_address", "ownerdata", "pet_data"],
    components: {
        PetButtonDropDown,
    },
    created(){
        this.getUserContacts()
        this.setEmergencyContacts();
    },
    watch:{
        pet_data:{
            handler(){
            this.setEmergencyContacts();
            }
        },
        ownerdata:{
            handler(){
            this.setEmergencyContacts();
            }
        }
    },
    data() {
        return {
            height: 12,
            pet_id: this.$route.params.pet_id,
            editAllergy: false,
            total: 0,
            feedback: null,
            status: "danger",
            processing: false,
            readyToAlertOwner: false,
            null_photo:
                "https://firebasestorage.googleapis.com/v0/b/petproject-qbelnc.appspot.com/o/site_assets%2Fdefault.png?alt=media&token=4ef975bf-e2b0-4725-8733-6401572d6067",
            pet_location: {
                line1: "",
                line2: "",
                city: "",
                state: "",
                zip: "",
            },
            errors: [],
            emerygencyContacts:[]
        };
    },
    methods: {
        getUserContacts() {
            let config = {
                headers:{
                    "userID": this.ownerdata._id
                }
            }
        axios.get(`${this.$api_path}/users/contacts`, config)
            .then(response => {
            if (response.data.status === 'success') {
                this.emerygencyContacts = response.data.result;
            } else {
                this.errorMessage = 'Error fetching contacts';
            }
            })
            .catch(error => {
            console.error('Error:', error);
            this.errorMessage = 'Error fetching contacts';
            });
        },
        getLabelData(label){
            let text = "EMERGENCY";
            let color = '#F36767';

            if(label == "parent"){
                text = "PARENT";
                color = "#555AEE"
            }else if(label == "family"){
                text = "FAMILY";
                color = "#1A89EF"
            }else if(label == "petSitter"){
                text = "PET SITTER";
                color = "#F5C042"
            }else if(label == "friend"){
                text = "FRIEND";
                color = "#5EB682"
            }

            return {
                text,color
            }
        },
        setEmergencyContacts(){
            let height = 12;
            if(this.pet_data && this.ownerdata){
                if(this.ownerdata.whatsapp){
                    height += 8;
                }
                let emerygencyContacts = [];
                this.ownerdata.contacts && this.ownerdata.contacts.forEach((contact)=>{
                    emerygencyContacts.push(contact);
                    height += contact.whatsapp ? 20 : 12;
                });

                if(this.pet_data.displayVetCard && this.pet_data.veternarian){
                    height += 16;
                }
                this.emerygencyContacts = emerygencyContacts;
                this.height = height;
        }
        },
        userAddressFmt(address) {
            let location = [];
            if (!address) {
                return "";
            }
            const addressKeys = ["line1", "line2", "city", "state", "zip"];
            addressKeys.forEach(idx => {
                if (address[idx]) {
                    location.push(address[idx]);
                }
            });
            if (!location) {
                return "Unknown Location";
            }
            return location.join(", ") + " " + address.country;
        },
        alertOwner() {
            this.$emit("alertOwner", "");
        },
        callUser() {
            window.open(`tel:${this.ownerdata.phone}`, "_self");
        },
        gotoLink(insta) {
            window.open(`https://www.instagram.com/${insta}`, "_blank");
        },
        showtLocationAlert(val) {
            this.readyToAlertOwner = val;
        },
        sendAlertByEmail() {
            this.processing = true;
            let payload = {
                pet_location: this.pet_location,
                otherID: this.otherID,
            };
            axios
                .post(this.$api_path + "petprofile/missing_pet_alert", payload)
                .then(res => {
                    this.feedback = res.data.feedback;
                    this.processing = false;
                })
                .catch(err => {
                    console.log(err);
                });
        },
    },
    computed: {
        ...mapState(["current_location"]),
    },
};
</script>
<style scoped>
.space-12 {
    padding: 6px 0px;
}
#ScannedContact {
    position: relative;
    width: 100%;
    min-height: 40vh;
    padding: 1rem 0;
    transition: 1s;
}

.bottom-btn {
    width: 100%;
    padding: 1.5rem;
    font-weight: bold;
    background-color: var(--primary);
    border: none;
    color: #fff;
    border-radius: 15px;
    transition: 1s;
    font-size: 1.5rem;
    cursor: pointer;
}
.btn-group {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
}
.hidden_contact {
    color: gray;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.hidden_contact img {
    height: 50px;
    width: 50px;
    margin: 7px;
}
.btn-gray {
    background-color: rgba(244, 245, 246, 0.7);
    border-radius: 12px;
    width: 95%;
    height: 40px;
    color: #6266f0;
    border: none;
    display: flex;
    align-items: center;
    padding: 4px 0.7rem;
    cursor: pointer;
    font-family: "Altis";
}
.btn-gray:active {
    background-color: #6266f0;
    color: #fff;
}
.btn-gray p {
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    width: 100%;
    line-height: 24px;
    margin: 0px;
}

.btn-gray-svg {
    background-color: #fff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    padding: 5px;
    align-items: center;
    height: 28px;
    width: 28px;
    box-sizing: border-box;
}
.btn-gray:active .btn-gray-svg {
    background-color: #7275f2;
}
.btn-gray-whatsapp:active{
    background-color: #5EB682 !important;
}
.btn-gray-whatsapp:active .btn-gray-svg{
    background-color: #6bb78a !important;
}
.left-btn {
    margin-right: 5px;
    margin-left: 5px;
    height: 48px;
    box-sizing: border-box;
    width: calc(100% - 10px);
}
.right-btn {
    margin-left: 5px;
    margin-right: 5px;
    height: 48px;
    box-sizing: border-box;
    width: calc(100% - 10px);
}

.bottom-btn2 {
    width: 100px;
    height: 38px;
    padding: 1.5rem;
    font-weight: bold;
    background-color: var(--primary);
    border: none;
    color: #fff;
    border-radius: 15px;
    /* transition: 1s; */
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.cancel-btn {
    background-color: #555;
}
/* ACCOUNT INFORMATION */

.account-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 0.5rem 0;
    transition: 1s;
    font-size: 0.8rem;
}
.account-info-text {
    margin: 0.5rem auto;
    font-weight: bold;
    position: relative;
    cursor: pointer;
    color: var(--primary);
}
.account-info-input {
    /* width: 10px;
  height: 10px; */
    width: 100%;
    opacity: 0;
    position: absolute;
    background-color: #000;
}
.input-group img {
    width: 1.2rem;
}
.input-w-label {
    margin-left: 1rem;
    width: 100%;
}
.input-w-label .login-input {
    padding: 0 !important;
    width: 100%;
    border: none;
}
.input-w-label .input-2-group {
    display: flex;
}
.input-w-label .input-2-group .short {
    width: 40%;
}
/*----------------------*\
|     PROFILE IMAGE
\*----------------------*/
.profile-image {
    width: 10rem;
    height: 10rem;
    margin-right: 2rem;
    border-radius: 100%;
    border: 3px solid var(--primary);
    overflow: hidden;
    position: relative;
    z-index: 10;
    /* Create the parallax scrolling effect */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    transition: 1s;
}
.parent2-image {
    border-color: var(--secondary);
}
.loader img {
    width: 8rem;
}
.parent-text {
    font-size: 1.1rem;
    color: var(--primary);
}
.parent2-text {
    color: var(--secondary);
}
/* ACCOUNT INFORMATION END */
.contact-container {
    position: relative;
    background-color: #f9f9f9;
    border-radius: 10px;
    width: 90%;
    min-height: 15rem;
    margin: 1rem auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
.contact-skeleton {
    width: 90%;
    margin: 1rem auto;
    display: flex;
    align-items: center;
}
.skeleton-img {
    width: 10rem;
    height: 10rem;
    margin-right: 2rem;
    border-radius: 100%;
    background: var(--primary);
}
.skeleton-text {
    display: flex;
    font-size: 1.5rem;
    flex-direction: column;
    transition: 1s;
}
.skeleton-name h2 {
    font-size: 1.2rem;
    color: #2d3142;
    font-family: "Altis Bold";
    font-weight: 600;
}
.profile-text {
    font-size: 1rem;
}
.skeleton-address {
    font-size: 1.2rem;
}
.selected-wrapper {
    background-color: var(--link-light);
    border-color: var(--link-light);
}
.selected {
    left: 70%;
}
.unactive {
    outline: none;
    cursor: not-allowed;
    background-color: #999;
}
.clean-buddies {
    background-color: #0cb7ee;
}
.no-contact-box {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 15rem;
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0 2px 30px 0 rgba(31, 38, 135, 0.15);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-radius: 10px;
}
.no-contact-box img {
    width: 8rem;
    transition: 1s;
    margin: 2rem auto;
}
.pic-upload {
    position: relative;
    width: 7rem;
    height: 7rem;
    margin: 3rem auto;
    text-align: center;
    overflow: hidden;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 70%;
}

.gallery-text {
    font-weight: bold;
    color: #adb6e1;
    text-align: center;
    font-size: 1.3rem;
}
.pic-upload:hover img {
    transform: translateY(-6px);
}

.pet-content {
    margin: 3rem auto;
    margin-top: 5rem;
    text-align: center;
}
.pet-header {
    text-align: center;
    margin: 1rem auto;
    margin-top: 2rem;
}
.pet-content-group {
    width: 100%;
}
.solo-alert {
    maw-width: 600px;
    width: 90%;
    margin: auto;
    transition: 1s;
}
.coalition-text {
    display: grid;
    text-align: center !important;
    width: 100%;
    row-gap: 10px;
    grid-template-columns: 50% 50%;
    margin: 0 auto;
    margin-bottom: 9px;
}
.coalition-text a {
    text-decoration: none;
}
.coalition-text button {
    text-align: center;
}
.red-alert {
    width: 100%;
    margin: 1rem 0.2rem;
    color: #fff;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 0.8rem;
    cursor: pointer;
    border-radius: 10px;
    font-family: "Altis";
    background-color: #c10600;
}
.red-alert img {
    width: 1.6rem;
    margin-right: 1.4rem;
}
.btn-gray img {
    width: 1.6rem;
    margin-right: 1.4rem;
}
.email-color {
    background-color: var(--primary);
}
/* SCAN LGOS  */
.vertical-divider {
    background-color: #adb6e1;
    width: 0.5px;
    height: 60px;
}
.selected {
    color: #fff;
}
v body[data-theme="dark"] .note-card {
    background-color: #444;
}
body[data-theme="dark"] .note-card-header,
body[data-theme="dark"] .gender-btn,
body[data-theme="dark"] .bottom-btn,
body[data-theme="dark"] .note-card-footer {
    background-color: #000;
}
body[data-theme="dark"] .cancel-btn {
    background-color: #555;
}
@media screen and (max-width: 900px) {
    .profile-image {
        margin-right: 1rem;
        border-width: 2.5px;
        width: 5rem;
        height: 5rem;
        min-width: 5rem;
        min-height: 5rem;
    }
}
@media screen and (max-width: 600px) {
    /* .profile-image{
    border-width: 2px;
    width: 4rem;
    height: 4rem;
    min-width: 4rem;
    min-height: 4rem;
  } */
    .skeleton-name h2 {
        font-size: 1rem;
    }
    .loader img {
        width: 4rem;
    }
    .setting-option {
        align-items: center;
        font-size: 0.6rem;
    }
    .contact-container {
        min-height: 0;
        margin-top: 2rem;
    }
    .private-container {
        margin-bottom: 4rem;
    }
    .contact-skeleton {
        margin-top: 2rem;
    }
    .no-contact-box {
        height: 10rem;
    }
    .pet-content {
        margin-top: 0rem;
    }
    .gallery-text {
        font-size: 1rem;
        margin-bottom: 1.1rem;
    }
    .pic-upload {
        width: 4rem;
        height: 4rem;
        margin: 1rem auto;
    }
    .skeleton-img {
        width: 5rem;
        height: 5rem;
        min-width: 5rem;
        min-height: 5rem;
        margin-right: 1rem;
    }
    .skeleton-address {
        font-size: 0.9rem;
    }
    .skeleton-text {
        font-size: 1rem;
    }
    .profile-text {
        font-size: 0.7rem;
    }
    .input-group p {
        font-size: 0.8rem;
    }
    .coalition-img {
        width: 60%;
    }
    .coalition-img img {
        width: 100%;
    }
    .red-alert img {
        width: 1.4rem;
    }
    .btn-gray img {
        width: 1.4rem;
    }
    .coalition-text button {
        text-align: center;
    }
    .red-alert {
        font-size: 0.8rem;
    }
    .btn-gray {
        font-size: 0.8rem;
    }
    .default-info-btn {
        padding: 0.5rem 0.8rem;
        font-size: 0.6rem;
    }
}
</style>
